import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  submenuPopup: {
    backgroundColor: theme.vars.palette.background.navigation,
    padding: theme.spacing(2),
    minWidth: '10rem'
  },
  submenuPopupHeader: {
    color: '#595b66',
    fontSize: '0.938rem',
    fontStyle: 'normal',
    fontWeight: 700,
    letterSpacing: '0em',
    lineHeight: '1.5rem',
    textAlign: 'left',
    marginBottom: '1rem'
  },
  submenuPopupButton: {
    color: 'rgba(255, 255, 255, 0.50)',
    height: theme.spacing(3),
    padding: theme.spacing(0, 1),
    width: '100%',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.10)',
      width: '100%'
    }
  },
  submenuPopupText: {
    '& > .MuiTypography-root': {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap'
    }
  },
  submenuPopupNavLink: {
    position: 'relative',
    textDecoration: 'none',
    width: '100%',
    zIndex: 0,
    '&.active': {
      width: '100%'
    },
    '&.active .MuiListItemButton-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      paddingLeft: theme.spacing(1),
      '& .MuiTypography-root': {
        color: theme.vars.palette.common.white
      }
    },
    '& .MuiListItemButton-root': {
      height: '2.5rem !important'
    }
  }
}));

export default useStyles;
